import React from 'react';
import './NotFound.css';

const NotFound = () => {
  const currentUrl = window.location.origin;
  const callbackUrl = `${currentUrl}/auth/callback`;

  const handleGoHome = () => {
    window.location.href = '/';
  };

  const handleTestCallback = () => {
    window.location.href = '/auth/callback?code=test_code_12345&state=test_provider';
  };

  return (
    <div className="notfound-container">
      <div className="notfound-card">
        <div className="error-icon">🔍</div>
        <h1 className="notfound-title">Page Not Found</h1>
        <p className="notfound-description">
          The page you're looking for doesn't exist on this OAuth bridge server.
        </p>

        <div className="available-routes">
          <h2>Available Routes</h2>
          <div className="route-list">
            <div className="route-item">
              <code className="route-path">/</code>
              <span className="route-desc">Home page with bridge information</span>
            </div>
            <div className="route-item">
              <code className="route-path">/auth/callback</code>
              <span className="route-desc">OAuth callback endpoint</span>
            </div>
          </div>
        </div>

        <div className="callback-info">
          <h2>OAuth Callback URL</h2>
          <p>Use this URL as your OAuth redirect URI:</p>
          <code className="callback-url">{callbackUrl}</code>
        </div>

        <div className="action-buttons">
          <button 
            className="btn btn-primary"
            onClick={handleGoHome}
          >
            Go to Home
          </button>
          <button 
            className="btn btn-secondary"
            onClick={handleTestCallback}
          >
            Test OAuth Callback
          </button>
        </div>

        <div className="help-text">
          <p>
            This is the EBM Safari OAuth Bridge. If you're seeing this page, you may have 
            navigated to an incorrect URL. Use the buttons above to go to the home page 
            or test the OAuth callback functionality.
          </p>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
